import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SimulationContext = createContext(null);

// Local, reversible what-if state. It never reaches Core: the real
// pause/enable is POST admin/agents/{id}/orders (verbs "pausar_tomas" /
// "habilitar"), which needs machines:admin (+ tokens:admin to enable) and an
// idempotent request_id. Leaving the Teams screen discards every override.
export function SimulationProvider({ children }) {
    const [overrides, setOverrides] = useState(() => new Map());

    const simulate = useCallback((seatId, controlState) => {
        setOverrides((current) => new Map(current).set(seatId, controlState));
    }, []);

    const undo = useCallback((seatId) => {
        setOverrides((current) => {
            const next = new Map(current);
            next.delete(seatId);
            return next;
        });
    }, []);

    const resetAll = useCallback(() => setOverrides(new Map()), []);

    const value = useMemo(() => ({ overrides, simulate, undo, resetAll }), [overrides, simulate, undo, resetAll]);
    return <SimulationContext.Provider value={value}>{children}</SimulationContext.Provider>;
}

export function useSimulation() {
    const context = useContext(SimulationContext);
    if (!context) throw new Error('useSimulation must be used inside <SimulationProvider>');
    return context;
}
